import React from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Typography,
} from "@mui/material";
import {
    PaymentsRounded,
} from "@mui/icons-material";

const PaymentModal = ({
    open,
    amount = 0,
    isLoading,
    onClose,
    onConfirm,
}) => {
    const formattedAmount = Number(amount || 0).toFixed(2);
    return (
        <Dialog
            open={open}
            onClose={isLoading ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    mx: 2,
                    maxWidth: "420px",
                    borderRadius: "24px",
                    overflow: "hidden",
                    boxShadow:
                        "0 25px 70px rgba(19, 76, 110, 0.3)",
                },
            }}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(12, 42, 58, 0.7)",
                    backdropFilter: "blur(5px)",
                },
            }}
        >
            <DialogContent
                sx={{
                    p: {
                        xs: 2.5,
                        sm: 3,
                    },
                    textAlign: "center",
                    background:
                        "linear-gradient(160deg, #ffffff 0%, #edf8fd 100%)",
                }}
            >
                <Box
                    sx={{
                        width: "72px",
                        height: "72px",
                        mx: "auto",
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "22px",
                        color: "#ffffff",
                        background:
                            "linear-gradient(145deg, #25ba6c, #1d9e59)",
                        boxShadow:
                            "0 14px 30px rgba(37, 186, 108, 0.25)",
                    }}
                >
                    <PaymentsRounded
                        sx={{
                            fontSize: "40px",
                        }}
                    />
                </Box>

                <Typography
                    component="h2"
                    sx={{
                        color: "#17364a",
                        fontSize: {
                            xs: "22px",
                            sm: "25px",
                        },
                        fontWeight: 800,
                        lineHeight: 1.2,
                        mb: 1,
                    }}
                >
                    Payment received? ₹{formattedAmount}
                </Typography>

                <Typography
                    sx={{
                        color: "#577383",
                        fontSize: "15px",
                        lineHeight: 1.6,
                        px: 1,
                    }}
                >
                    Please confirm that the customer&apos;s payment
                    has been successfully received on the Pine Labs
                    terminal.
                </Typography>

                <Typography
                    sx={{
                        mt: 1,
                        color: "#d56a32",
                        fontSize: "13px",
                        fontWeight: 700,
                        lineHeight: 1.5,
                    }}
                >
                    The order will be created after confirmation.
                </Typography>

                <Box
                    sx={{
                        mt: 3,
                        display: "flex",
                        gap: 1.2,
                    }}
                >
                    <Button
                        variant="outlined"
                        disabled={isLoading}
                        onClick={onClose}
                        sx={{
                            flex: 1,
                            minHeight: "48px",
                            borderRadius: "14px",
                            borderWidth: "2px",
                            borderColor: "#9ecadd",
                            color: "#306781",
                            fontWeight: 800,
                            textTransform: "none",

                            "&:hover": {
                                borderWidth: "2px",
                                borderColor: "#67add0",
                            },
                        }}
                    >
                        Not yet
                    </Button>

                    <Button
                        variant="contained"
                        disabled={isLoading}
                        onClick={onConfirm}
                        sx={{
                            flex: 1,
                            minHeight: "48px",
                            borderRadius: "14px",
                            background:
                                "linear-gradient(145deg, #25ba6c, #1d9e59)",
                            fontWeight: 800,
                            textTransform: "none",
                            boxShadow:
                                "0 10px 22px rgba(37, 186, 108, 0.25)",

                            "&:hover": {
                                background:
                                    "linear-gradient(145deg, #20ad62, #188c4e)",
                            },
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress
                                size={22}
                                sx={{
                                    color: "#ffffff",
                                }}
                            />
                        ) : (
                            "Yes, received"
                        )}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentModal;